/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 05/06/2023.
 */
import React from 'react'
import { Link } from 'gatsby'
import { CONTACT_PAGE } from '../../pages'
import Button from '../Button'

const KitchenInfo = ({ product }) => {
  return (
    <>
      <div className="row " style={{}}>
        <div className="col-12 col-md-8 mb-4 mt-4 mb-md-7 mx-auto px-4" style={{ minHeight: 300 }}>
          <p className="opacity-75">Inspiration</p>
          <h3 className="fw-bold mt-1 mb-4">{product.typeText}</h3>
          <h6 className="lh" style={{ maxWidth: 600 }}>
            {product.text}
          </h6>
        </div>

        <div className="col-12 col-md-4 pt-4 mt-md-5 px-0 ">
          <div className="rounded-1 bg-white border" style={{ boxShadow: '0px 3px 15px -2px rgba(0, 0, 0, 0.06  )' }}>
            <div className=" py-4 px-4 ">
              <p className="p-small mb-2 opacity-75  ">Perfekt til alle køkken skabe</p>
              <h6 className="text-black fw-bold">
                {product.name} passer perfekt til alle <br />
                METOD over- og underskabe
              </h6>
            </div>
            <div className="py-4 px-4 " style={{ borderTop: '1px solid #E8E8E8', borderBottom: '1px solid #E8E8E8' }}>
              <p className="p-small mb-2 opacity-75">Fås til følgende kollektioner</p>
              <h6 className="fw-bold">{product.name} passer også til PAX</h6>
            </div>

            <div className="pt-4 pb-5 px-4  d-flex align-items-center justify-content-between">
              <div className="">
                {/*<p className="p-small mb-2 opacity-75">Har du spørgsmål</p>*/}
                {/*<h6 className="fw-bold">Vi står klar til at hjælpe</h6>*/}
                <h6 className="fw-bold mt-1">Har du spørgsmål?</h6>
              </div>
              <Link to={CONTACT_PAGE.to} className="text-decoration-none mt-2">
                <Button title="Kontakt os"></Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default KitchenInfo
